import { boot } from 'quasar/wrappers'
import { EventBus } from 'quasar'

const busInstance = new EventBus()
const bus = {
  $on: (...args) => busInstance.on(...args),
  $once: (...args) => busInstance.once(...args),
  $off: (...args) => busInstance.off(...args),
  $emit: (...args) => busInstance.emit(...args),
}

export default boot(({ app }) => {
  app.config.globalProperties.$bus = bus
})

export { bus }
